/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE UPLOAD : GIF --------------- ++++++++++ */
export default theme => ({
    gif: {
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        margin:pxToEm(5),
        '& img':{
            width:pxToEm(150),
            height:'auto'
        }
    }
});
